import { useParams } from "react-router-dom";

export default function useOrgId(): string | undefined {
  const { orgId } = useParams();
  return orgId;
}
